<template>
  <div class="video-card">
    <div class="video-card__video">
      <video ref="videoRef" :src="videoUrl" @loadedmetadata="handleDurationChange"></video>
    </div>
    <div class="video-card__info">
      <div class="video-card__container video-card__info-type">
        <span>文件</span>
      </div>
      <div v-if="fileSize" class="video-card__container video-card__info-size">
        <span>{{ fileSize }}MB</span>
      </div>
      <div class="video-card__container video-card__info-duration">
        <span>{{ fileDuration }}</span>
      </div>
      <div v-if="uploading" class="upload-progress">
        <el-progress :percentage="uploadingPercent" type="circle" :width="40" />
      </div>
      <template v-else>
        <div v-if="videoStatus === 'pause'" class="video-card__play">
          <i
            class="icon-play-circle-fill t-iconfont"
            style="font-size: 32px"
            @click="handlePlay"
          ></i>
        </div>
        <div v-else class="video-card__play">
          <i
            class="icon-pause-circle-fill t-iconfont"
            style="font-size: 32px"
            @click="handlePlay"
          ></i>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, ref, watch } from 'vue'

const props = defineProps({
  file: {
    type: File,
    default: null
  },
  uploading: {
    type: Boolean,
    default: false
  },
  uploadingPercent: {
    type: Number,
    default: 0
  }
})

const videoRef = ref(null)
const fileDuration = ref('00:00:00')
const videoUrl = ref('')
let videoObjectUrl = ''

const updateVideoUrl = (file) => {
  if (videoObjectUrl) URL.revokeObjectURL(videoObjectUrl)
  videoObjectUrl = ''
  videoUrl.value = typeof file === 'string' ? file : file ? URL.createObjectURL(file) : ''
  if (typeof file !== 'string') videoObjectUrl = videoUrl.value
}

watch(() => props.file, updateVideoUrl, { immediate: true })
onBeforeUnmount(() => {
  if (videoObjectUrl) URL.revokeObjectURL(videoObjectUrl)
})

const fileSize = computed(() => {
  if (typeof props.file !== File) {
    return null
  }
  return props.file && (props.file.size / 1024 / 1024).toFixed(2)
})

const videoStatus = ref('pause')

const formatDuration = (duration) => {
  if (!duration) return '00:00:00'
  const hours = Math.floor(duration / 3600)
  const minutes = Math.floor((duration % 3600) / 60)
  const seconds = Math.floor(duration % 60)
  return [hours, minutes, seconds].map((val) => val.toString().padStart(2, '0')).join(':')
}

const handleDurationChange = () => {
  console.log('handleDurationChange')
  fileDuration.value = formatDuration(videoRef.value.duration)
}

const handlePlay = () => {
  if (videoRef.value.paused) {
    videoRef.value.play()
    videoStatus.value = 'play'
  } else {
    videoRef.value.pause()
    videoStatus.value = 'pause'
  }
}
</script>

<style scoped lang="less">
.video-card {
  width: 100%;
  height: 162px;
  overflow: hidden;
  position: relative;
  border-radius: 8px;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  .video-card__info {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    .upload-progress {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .video-card__play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      cursor: pointer;
    }

    .video-card__container {
      position: absolute;
      padding: 2px 4px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
    }

    .video-card__info-type {
      top: 8px;
      right: 8px;
      background-color: rgba(0, 0, 0, 0.5);
      color: #fff;
    }

    .video-card__info-size {
      bottom: 8px;
      left: 8px;
    }

    .video-card__info-duration {
      bottom: 8px;
      right: 8px;
    }
  }
}
</style>
